import { Component, OnInit, OnDestroy, Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subscription, BehaviorSubject, interval, Subject } from 'rxjs';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { ValidationTools } from 'appshared/validation-tools';
import { TextTools } from 'appshared/text-tools';
import { UITools } from 'appshared/ui-tools';
import { SharedLicenseTools } from 'appshared/shared-license-tools';

import { PlatformsService } from '../platforms.service';
import { AuthService } from 'client/app/services/auth.service';

@Component({
	selector: 'app-platform-list',
	templateUrl: './platform-list.component.html',
	styleUrls: ['./platform-list.component.scss']
})
export class PlatformListComponent implements OnInit, OnDestroy {
	ac = AppConstants;
	tt = TextTools;
	mt = MiscTools;
	ut = UITools;

	// 'standard' list stuff
	platforms: Models.Platform[];
	loading = true;
	refreshing = false;
	private listSubscription: Subscription;

	private userSubscription: Subscription;
	canAdd = false;

	constructor(
		private authService: AuthService,
		private platformsService: PlatformsService) { }

	ngOnInit(): void {
		this.loading = true;

		this.listSubscription = this.platformsService.platforms.subscribe(platforms => {
			this.platforms = platforms;
			if (this.platforms) {
				this.platforms.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
				this.loading = false;
			}
		});

		this.userSubscription = this.authService.user.subscribe(authUser => {
			this.canAdd = authUser && ValidationTools.checkAccess(authUser, 'manage-platforms');
		});

		// Start List Auto Refresh
		// this.startListRefresh();
	}

	ngOnDestroy() {
		if (this.userSubscription) this.userSubscription.unsubscribe();
		if (this.listSubscription) this.listSubscription.unsubscribe();
	}

	async refresh() {
		this.refreshing = true;
		try {
			await this.platformsService.refreshAll().toPromise();
		} catch (err: any) {
			// console.error('Caught an error refreshing list');
		}
		this.refreshing = false;
	}
}
